import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitSix = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-6%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 1.71 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 1.71 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1549"
      height="672"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitSix"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M1545.15 542.193c-9.71 36.249-40.43 65.107-87.84 86.212-47.4 21.103-111.4 34.417-187.53 39.614-152.24 10.395-352.827-11.683-565.669-68.714C491.269 542.274 306.514 461.1 179.866 375.977c-63.326-42.563-112.1-86.097-142.599-128.073C6.765 205.924-5.41 165.572 4.302 129.323c9.713-36.25 40.434-65.108 87.84-86.213 47.4-21.102 111.407-34.417 187.53-39.614C431.914-6.9 632.503 15.18 845.345 72.21c212.845 57.03 397.595 138.205 524.245 223.327 63.33 42.563 112.1 86.097 142.6 128.073 30.5 41.98 42.68 82.333 32.96 118.582Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="1920.84"
          x2="2159.76"
          y1="1190.22"
          y2="684.992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-6@2x.png`}
        width="50"
        height="50"
        x={isDesktop ? 1370 : 900}
        y={620}
      >
        <mpath href="#orbitSix" />
      </image>
    </motion.svg>
  );
};

export default OrbitSix;
